import { css } from '@emotion/core';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Colors, Link, Typography } from '@zapier/design-system';
export const CssVars = {
    justifyContent: '--UniversalFooter__HelpfulLinks-justify-content',
};
const Styles = {
    root: css `
    ${Typography.smallPrint1Semibold};
    color: ${Colors.neutral700};
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: var(${CssVars.justifyContent}, center);
    row-gap: 10px;
  `,
    copyright: css `
    margin-right: 10px;
  `,
    links: css `
    display: inherit;
    align-items: inherit;
    justify-content: inherit;
    white-space: nowrap;
  `,
    linkItem: css `
    border-left: 1px solid ${Colors.neutral400};
    &:first-of-type {
      border-left: none;
    }
  `,
    link: (isButton = false) => css `
    // Increase hit area and separate.
    padding: ${isButton ? '0' : '5px'} 10px;
    color: ${Colors.neutral700} !important;
    text-decoration: none;
    &:hover,
    &:focus {
      color: ${Colors.blue} !important;
      outline: none;
    }
  `,
};
export const ZapierMeta = (props) => {
    const linkNodes = props.links.map((link) => {
        const content = link.href ? (isolateComponent(Link, { css: Styles.link(false), color: null, href: link.href }, link.text)) : (isolateComponent("button", { className: link.className, css: Styles.link(true), style: link.style, type: "button" }, link.text));
        return (isolateComponent("li", { key: link.text, css: Styles.linkItem }, content));
    });
    return (isolateComponent("div", { css: Styles.root },
        isolateComponent("p", { css: Styles.copyright },
            "\u00A9 ",
            new Date().getFullYear(),
            " Zapier Inc."),
        isolateComponent("ul", { css: Styles.links }, linkNodes)));
};
ZapierMeta.defaultProps = {
    links: [
        {
            text: 'Manage cookies',
            className: 'ot-sdk-show-settings',
            style: { display: 'none' },
        },
        { text: 'Legal', href: '/legal' },
        { text: 'Privacy', href: '/privacy' },
    ],
};
//# sourceMappingURL=ZapierMeta.js.map
// @zapier/universal-layout@5.12.61 (4902ab0c1)
